import { Component, Mixins } from 'vue-property-decorator';
import { MagicConfigMixin } from '@gig/magic-common';

import { isSOWHidden } from '../../services/routing/guards/sow.guard';

@Component({
    name: 'source-of-wealth-manager',
})
export default class SourceOfWealthManager extends Mixins(MagicConfigMixin) {
    get isGracePeriodPrompHidden() {
        return isSOWHidden(this.$route);
    }
}
